import React, { useState, useEffect, useRef } from "react";
import {
  VStack,
  HStack,
  Button,
  IconButton,
  Icon,
  Text,
  NativeBaseProvider,
  Center,
  Box,
  StatusBar,
  Divider,
  Stack,
  Menu,
  HamburgerIcon,
  Pressable,
  Avatar,
  Image,
  Modal,
} from "native-base";
import { useWindowDimensions,StyleSheet,ImageBackground } from "react-native";
import { useNavigation } from "@react-navigation/native";
import { GlobalStyles } from "../constants/styles";
import { useSelector, useDispatch } from "react-redux";
import SetUser from "../redux/user/SetUser";
import { GlobalConstants } from "../constants/constants";

function AppBar() {
  const dispatch = useDispatch();
  let user = useSelector((state) => state.user.user);
  console.log("=================================");
  console.log(user);
  const { width } = useWindowDimensions();
  const isMobile = width < 768;

  const navigation = useNavigation();

  const [signInColor, setSignInColor] = useState(GlobalStyles.colors.blue);
  const [signInTextColor, setSignInTextColor] = useState(
    GlobalStyles.colors.white
  );
  const [signUpColor, setSignUpColor] = useState(GlobalStyles.colors.blue);
  const [signUpTextColor, setSignUpTextColor] = useState(
    GlobalStyles.colors.white
  );

  const [signInGuestColor, setSignInGuestColor] = useState(GlobalStyles.colors.blue);
  const [signInGuestTextColor, setSignInGuestTextColor] = useState(
    GlobalStyles.colors.white
  );

  const [settingsColor, setSettingsColor] = useState(GlobalStyles.colors.blue);
  const [settingsTextColor, setSettingsTextColor] = useState(
    GlobalStyles.colors.white
  );

  const [headerNameColor, setHeaderNameColor] = useState(
    GlobalStyles.colors.blue
  );

  const [whyTownTicksColor, setWhyTownTicksColor] = useState(
    GlobalStyles.colors.blue
  );
 

  const [modalVisible, setModalVisible] = useState(false);
  const initialRef = useRef(null);
  const finalRef = useRef(null);

  useEffect(async () =>  {
    changeColor("");

  }, []);

  function getAvatarChar(email) {
    let nameShortCode = "";
    if (email) {
      nameShortCode = email.charAt(0).toUpperCase();
    }
    return nameShortCode;
  }
  //header icons functions

 

  function changeColor(btnType) {
    if (btnType === "WhyTownTicks") {
      setWhyTownTicksColor(GlobalStyles.colors.mustard);
      setSignUpColor(GlobalStyles.colors.blue);
      setSignInColor(GlobalStyles.colors.blue);
      setSignInGuestColor(GlobalStyles.colors.blue);
      setSignUpTextColor(GlobalStyles.colors.white);
      setSignInTextColor(GlobalStyles.colors.white);
      setSignInGuestTextColor(GlobalStyles.colors.white);
    } else if (btnType === "SignUp") {
      setWhyTownTicksColor(GlobalStyles.colors.blue);
      setSignUpColor(GlobalStyles.colors.white);
      setSignInColor(GlobalStyles.colors.blue);
      setSignInGuestColor(GlobalStyles.colors.blue);
      setSignUpTextColor(GlobalStyles.colors.mustard);
      setSignInTextColor(GlobalStyles.colors.white);
      setSignInGuestTextColor(GlobalStyles.colors.white);
    } else if (btnType === "SignIn") {
      setWhyTownTicksColor(GlobalStyles.colors.blue);
      setSignUpColor(GlobalStyles.colors.blue);
      setSignInColor(GlobalStyles.colors.white);
      setSignInGuestColor(GlobalStyles.colors.blue);
      setSignUpTextColor(GlobalStyles.colors.white);
      setSignInTextColor(GlobalStyles.colors.mustard);
      setSignInGuestTextColor(GlobalStyles.colors.white);
    } else if (btnType === "SignInGuest") {
      setWhyTownTicksColor(GlobalStyles.colors.blue);
      setSignUpColor(GlobalStyles.colors.blue);
      setSignInColor(GlobalStyles.colors.blue);
      setSignInGuestColor(GlobalStyles.colors.white);
      setSignUpTextColor(GlobalStyles.colors.white);
      setSignInTextColor(GlobalStyles.colors.white);
      setSignInGuestTextColor(GlobalStyles.colors.mustard);
    } else if (btnType === "Settings") {
      setWhyTownTicksColor(GlobalStyles.colors.blue);
      setSignUpColor(GlobalStyles.colors.blue);
      setSignInColor(GlobalStyles.colors.blue);
      setSignInGuestColor(GlobalStyles.colors.blue);
      setSignUpTextColor(GlobalStyles.colors.white);
      setSignInTextColor(GlobalStyles.colors.white);
      setSignInGuestTextColor(GlobalStyles.colors.white);
    } else {
      setWhyTownTicksColor(GlobalStyles.colors.blue);
      setSignUpColor(GlobalStyles.colors.blue);
      setSignInColor(GlobalStyles.colors.blue);
      setSignInGuestColor(GlobalStyles.colors.blue);
      setSignUpTextColor(GlobalStyles.colors.white);
      setSignInTextColor(GlobalStyles.colors.white);
      setSignInGuestTextColor(GlobalStyles.colors.white);
    }
  }

  return (
    <>
    
    {!user? (
     <Center>
     <Box safeAreaTop bg="white" />
     <ImageBackground
                 source={require("../../assets/Home/header.png")}
                 resizeMode="stretch"
                 style={{
                   width: "100%",
                 }}
               >
      <HStack
        //  bg="muted.100"
        px="1"
        py="3"
        justifyContent="space-between"
        alignItems="center"
        w="100%"
        // bgColor="#ffe16d"
        // maxW="900"
      >
        <Center w={[150, 150, 300]}>
          <Pressable
            onPress={() => {
              // window.location.reload();
              navigation.navigate("Home");
            }}
          >
            <HStack alignItems="center">
              <Image
                source={require("../../assets/tt_logo.png")}
                alt="Alternate Text"
                size="xs"
              />
              {window?.innerWidth > 780 ? (
                <>
                  <Text style={styles.textWithShadow}>TownTicks</Text>
                </>
              ) : (
                <>
                <Text style={styles.textWithShadowMobile}>TownTicks</Text>
                </>
              )}
            </HStack>
          </Pressable>
        </Center>
        {/* <Center w={[75, 350, 600]}>
          <Stack
            flexDirection={window?.innerWidth < 415 ? "column" : "row"}
            justifyContent="center"
          >
            {!user ? (
              <Button
                onPress={() => {
                  changeColor("WhyTownTicks");
                  navigation.navigate("WhyTownTicks");
                }}
                colorScheme="primary"
                size="md"
                variant="link"
              >
                <Text
                  w={[75, 150, 150]}
                  color={whyTownTicksColor}
                  fontFamily={GlobalStyles.text.fontFamily}
                  fontSize={"lg"}
                  fontWeight="bold"
                >
                  Why Town Ticks?
                </Text>
              </Button>
            ) : (
              <>
                
              </>
            )}
          </Stack>
        </Center> */}

        

        
        <Center w={[200, 200, 350]}>
          <Stack
            flexDirection={"row"}
            justifyContent="center"
            mx={10}
            bgColor="#ffe16d"
          >
            {!user ? (
              <>
                  <Button
                  size="sm"
                  variant={"solid"}
                  px="3"
                  bg="#ffe16d"
                  borderColor="#22004B"
                  borderWidth={2}
                  borderRadius="10px"
                  mr={2}
                  _hover={{ bg: GlobalStyles.colors.grey }}
                  onPress={() => {
                    changeColor("SignInGuest");
                    navigation.navigate("SignInGuest");
                  }}
                >
                  <Text fontWeight="bold" color="#22004B">
                    Guest
                  </Text>
                </Button>
                {/* <Button
                  size="sm"
                  variant={"solid"}
                  px="3"
                  bg={GlobalStyles.colors.blue}
                  borderColor={GlobalStyles.colors.white}
                  borderWidth={2}
                  onPress={() => {
                    setModalVisible(!modalVisible);
                  }}
                >
                  <Text fontWeight="bold" color={GlobalStyles.colors.white}>
                    Contact Us
                  </Text>
                </Button> */}
                {/* <Button
                  size="sm"
                  variant={"solid"}
                  px="3"
                  bg={signUpColor}
                  borderColor={signUpTextColor}
                  borderWidth={2}
                  onPress={() => {
                    changeColor("SignUp");
                    navigation.navigate("SignUp");
                  }}
                >
                  <Text fontWeight="bold" color={signUpTextColor}>
                    Sign Up
                  </Text>
                </Button> */}
                <Button
                  size="sm"
                  variant={"solid"}
                  px="3"
                  bg={signInColor}
                  borderColor="#22004B"
                  borderWidth={2}
                  borderRadius="10px"
                  _hover={{ bg: GlobalStyles.colors.grey }}
                  onPress={() => {
                    changeColor("SignIn");
                    navigation.navigate("SignIn");
                  }}
                >
                  <Text fontWeight="bold" color={signInTextColor}  
                  _hover={{ color: GlobalStyles.colors.blue }} // Text color on hover
                  >
                    Log In
                  </Text>
                </Button>
                <Button
                  size="sm"
                  variant={"solid"}
                  px="3"
                  bg={signUpColor}
                  borderColor="#22004B"
                  borderWidth={2}
                  borderRadius="10px"
                  ml={2}
                  _hover={{ bg: GlobalStyles.colors.grey }}
                  onPress={() => {
                    changeColor("SignUp");
                    navigation.navigate("AvailableCities");
                  }}
                >
                  <Text fontWeight="bold" color={signUpTextColor} _hover={{ color: GlobalStyles.colors.blue }} >
                    {isMobile ? "Cities" : "Available Cities"}
                  </Text>
                </Button>
              </>
            ) : (
              <>
                <Menu
                  w="190"
                  placement={"bottom right"}
                  trigger={(triggerProps) => {
                    return (
                      <Pressable
                        accessibilityLabel="More options menu"
                        {...triggerProps}
                      >
                        <Image source={require("../../assets/side-bar-icons/gg_menu-grid-r.png")} alt="card-icon" size="40px"/>
                        {/* <HamburgerIcon size="md" mt={2} /> */}
                        {/* <Avatar
                          size="sm"
                          source={{
                            uri: GlobalConstants.notFoundImageUrl,
                          }}
                          bg={GlobalStyles.colors.blue}
                        >
                          {getAvatarChar(user.email)}
                        </Avatar> */}
                      </Pressable>
                    );
                  }}
                >
                  <Menu.Item isDisabled>
                    <Text
                      fontWeight="bold"
                      fontFamily={GlobalStyles.text.fontFamily}
                      color={GlobalStyles.colors.blue}
                    >
                      {user.profile ? user.profile.name : user.email}
                    </Text>
                  </Menu.Item>
                  <Menu.Item
                    onPress={() => {
                      changeColor("Settings");
                      navigation.navigate("Settings");
                    }}
                  >
                    <Text color={GlobalStyles.colors.blue}>Settings</Text>
                  </Menu.Item>
                  <Menu.Item
                    onPress={() => {
                      setModalVisible(!modalVisible);
                    }}
                  >
                    <Text color={GlobalStyles.colors.blue}>Contact Us</Text>
                  </Menu.Item>
                  <Menu.Item
                    onPress={() => {
                      dispatch(SetUser.action(null));
                      navigation.navigate("Home");
                    }}
                  >
                    <Text color={GlobalStyles.colors.blue}>Logout</Text>
                  </Menu.Item>
                </Menu>
              </>
            )}
          </Stack>
        </Center>
      </HStack>
     </ImageBackground>
     <Divider bg={GlobalStyles.colors.homeDivider} w="100%" />
   </Center>
    ): user.user_category !== 1 && user.user_category !== 0 ? (
      <Center>
        <Box safeAreaTop bg="white" />
        <HStack
          bg="muted.100"
          px="1"
          py="3"
          justifyContent="space-between"
          alignItems="center"
          w="100%"
          // maxW="900"
        >
          <Center w={[150, 150, 300]}>
            <Pressable
              onPress={() => {
                // window.location.reload();
                navigation.navigate("Home");
              }}
            >
              <HStack alignItems="center">
                <Image
                  source={require("../../assets/tt_logo.png")}
                  alt="Alternate Text"
                  size="xs"
                />
                {window?.innerWidth > 780 ? (
                  <>
                    <Text style={styles.textWithShadow}>TownTicks</Text>
                  </>
                ) : (
                  <>
                  <Text style={styles.textWithShadowMobile}>TownTicks</Text>
                  </>
                )}
              </HStack>
            </Pressable>
          </Center>
          <Center w={[75, 350, 600]}>
            <Stack
              flexDirection={window?.innerWidth < 415 ? "column" : "row"}
              justifyContent="center"
            >
              {!user ? (
                <Button
                  onPress={() => {
                    changeColor("WhyTownTicks");
                    navigation.navigate("WhyTownTicks");
                  }}
                  colorScheme="primary"
                  size="md"
                  variant="link"
                >
                  <Text
                    w={[75, 150, 150]}
                    color={whyTownTicksColor}
                    fontFamily={GlobalStyles.text.fontFamily}
                    fontSize={"lg"}
                    fontWeight="bold"
                  >
                    Why TownTicks?
                  </Text>
                </Button>
              ) : (
                <>
                  
                </>
              )}
            </Stack>
          </Center>

          

          
          <Center w={[75, 150, 300]}>
            <Stack
              flexDirection={"row"}
              justifyContent="center"
              mx={10}
            >
              {!user ? (
                <>
                    <Button
                    size="sm"
                    variant={"solid"}
                    px="3"
                    bg={signInGuestColor}
                    borderColor={signInGuestTextColor}
                    borderWidth={2}
                    onPress={() => {
                      changeColor("SignInGuest");
                      navigation.navigate("SignInGuest");
                    }}
                  >
                    <Text fontWeight="bold" color={signInGuestTextColor}>
                      Guest
                    </Text>
                  </Button>
                  {/* <Button
                    size="sm"
                    variant={"solid"}
                    px="3"
                    bg={GlobalStyles.colors.blue}
                    borderColor={GlobalStyles.colors.white}
                    borderWidth={2}
                    onPress={() => {
                      setModalVisible(!modalVisible);
                    }}
                  >
                    <Text fontWeight="bold" color={GlobalStyles.colors.white}>
                      Contact Us
                    </Text>
                  </Button> */}
                  <Button
                    size="sm"
                    variant={"solid"}
                    px="3"
                    bg={signUpColor}
                    borderColor={signUpTextColor}
                    borderWidth={2}
                    onPress={() => {
                      changeColor("SignUp");
                      navigation.navigate("SignUp");
                    }}
                  >
                    <Text fontWeight="bold" color={signUpTextColor}>
                      Sign Up
                    </Text>
                  </Button>
                  <Button
                    size="sm"
                    variant={"solid"}
                    px="3"
                    bg={signInColor}
                    borderColor={signInTextColor}
                    borderWidth={2}
                    onPress={() => {
                      changeColor("SignIn");
                      navigation.navigate("SignIn");
                    }}
                  >
                    <Text fontWeight="bold" color={signInTextColor}>
                      Log In
                    </Text>
                  </Button>
                </>
              ) : (
                <>
                  <Menu
                    w="190"
                    placement={"bottom right"}
                    trigger={(triggerProps) => {
                      return (
                        <Pressable
                          accessibilityLabel="More options menu"
                          {...triggerProps}
                        >
                          <Image source={require("../../assets/side-bar-icons/gg_menu-grid-r.png")} alt="card-icon" size="40px"/>
                          {/* <HamburgerIcon size="md" mt={2} /> */}
                          {/* <Avatar
                            size="sm"
                            source={{
                              uri: GlobalConstants.notFoundImageUrl,
                            }}
                            bg={GlobalStyles.colors.blue}
                          >
                            {getAvatarChar(user.email)}
                          </Avatar> */}
                        </Pressable>
                      );
                    }}
                  >
                    <Menu.Item isDisabled>
                      <Text
                        fontWeight="bold"
                        fontFamily={GlobalStyles.text.fontFamily}
                        color={GlobalStyles.colors.blue}
                      >
                        {user.profile ? user.profile.name : user.email}
                      </Text>
                    </Menu.Item>
                    <Menu.Item
                      onPress={() => {
                        changeColor("Settings");
                        navigation.navigate("Settings");
                      }}
                    >
                      <Text color={GlobalStyles.colors.blue}>Settings</Text>
                    </Menu.Item>
                    <Menu.Item
                      onPress={() => {
                        setModalVisible(!modalVisible);
                      }}
                    >
                      <Text color={GlobalStyles.colors.blue}>Contact Us</Text>
                    </Menu.Item>
                    <Menu.Item
                      onPress={() => {
                        dispatch(SetUser.action(null));
                        navigation.navigate("Home");
                      }}
                    >
                      <Text color={GlobalStyles.colors.blue}>Logout</Text>
                    </Menu.Item>
                  </Menu>
                </>
              )}
            </Stack>
          </Center>
        </HStack>
        <Divider bg={GlobalStyles.colors.homeDivider} w="100%" />
      </Center>
    ) : (
      <></>
    )}
      
      

      <Modal
        isOpen={modalVisible}
        onClose={() => setModalVisible(false)}
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
      >
        <Modal.Content>
          <Modal.CloseButton />
          <Modal.Header>Contact Us</Modal.Header>
          <Modal.Body>
            <Text>
              To contact or any feedback about TownTicks, write to
              <Text color={GlobalStyles.colors.blue}>
                {" "}
                support.townticks@novelma.com
              </Text>
            </Text>
          </Modal.Body>
          <Modal.Footer>
            <Button.Group space={2}>
              <Button
                variant="ghost"
                colorScheme="blueGray"
                onPress={() => {
                  setModalVisible(false);
                }}
              >
                Close
              </Button>
            </Button.Group>
          </Modal.Footer>
        </Modal.Content>
      </Modal>
    </>
  );
}

const styles = StyleSheet.create({
  textWithShadow: {
    fontSize: 30,
    color: GlobalStyles.colors.mustard,
    fontFamily: GlobalStyles.text.fontFamily,
    textShadowColor: "#585858",
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 0,
  },
  textWithShadowMobile: {
    fontSize: 15,
    color: GlobalStyles.colors.mustard,
    fontFamily: GlobalStyles.text.fontFamily,
    textShadowColor: "#585858",
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 0,
  },
});

export default AppBar;
